import Switcher from './Switcher.vue';

export default Switcher;


// WEBPACK FOOTER //
// ./src/components/parts/nav/switcher/index.js